module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('transportationDetailsDialog', {
    ref: "openDialog"
  })], 1), _vm._v(" "), _c('transportationDetailsList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-transportation": _vm.editTransportation,
      "view-transportation": _vm.viewTransportation
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f86ffd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/billsundry/transportationDetails.vue
// module id = 2236
// module chunks = 0